import {
  PushNotifications,
  Token,
  PushNotificationSchema,
  ActionPerformed,
} from '@capacitor/push-notifications';
import {Capacitor} from "@capacitor/core";
import localForage from "localforage";
import {appStore} from "global.state";
import fb from "../firebase";

const isSupported = (): boolean => {
  return Capacitor.isNativePlatform();
}

type cancelFunction = () => void;

export const enablePushNotifications = async (listeners: cancelFunction[]): Promise<boolean> => {
  if (!isSupported()) {
    // console.log('== DEBUG: Push messages disabled, not native platform');
    return false;
  }

  // clean listeners
  listeners.forEach(i => i());

  // add listeners
  const addList = await PushNotifications.addListener(
    'registration',
    onRegistrationSuccess,
  );
  listeners.push(addList.remove);

  const regErrorList = await PushNotifications.addListener('registrationError', (error: any) => {
    // console.log('DEBUG (PUSH): Error on registration: ' + JSON.stringify(error));
    console.log('DEBUG (PUSH): Error on registration');
  });
  listeners.push(regErrorList.remove);

  const pushRecList = await PushNotifications.addListener(
    'pushNotificationReceived',
    onPushNotificationReceived,
  );
  listeners.push(pushRecList.remove);

  const pushActPerfList = await PushNotifications.addListener(
    'pushNotificationActionPerformed',
    onPushNotificationActionPerformed,
  );
  listeners.push(pushActPerfList.remove);

  let permStatus = await PushNotifications.checkPermissions();

  if (permStatus.receive === 'prompt' || permStatus.receive === 'prompt-with-rationale') {
    permStatus = await PushNotifications.requestPermissions();
  }

  if (permStatus.receive !== 'granted') {
    console.log('DEBUG (PUSH): Push notifications not granted');
    return false;
  }

  await PushNotifications.register();

  return true;
};

const onRegistrationSuccess = async (token: Token) => {
  console.log('DEBUG (PUSH): Push registration success');
  await localForage.setItem('fcmToken', token.value);
  await updateDeviceToken();
}

const onPushNotificationReceived = (notification: PushNotificationSchema) => {
  // console.log('DEBUG (PUSH): Push received: ' + JSON.stringify(notification));
  console.log('DEBUG (PUSH): Push received');
}

const onPushNotificationActionPerformed = async (action: ActionPerformed) => {
  console.log('DEBUG (PUSH): Push action performed');
  // console.log('DEBUG (PUSH): Push action performed: ' + JSON.stringify(action));
}

export const updateDeviceToken = async () => {
  if (!isSupported())
    return;

  const store = appStore.getState();
  const fcmToken = await localForage.getItem<string>('fcmToken');
  const {app} = store;

  if (fcmToken && app.loggedIn) {
    const {deviceInfo} = app;

    // update User fcmToken
    const deviceRef = fb.db.collection('devices').doc(fcmToken);
    const data: any = {
      owner: app.user.uid,
      fcmToken,
      platform: deviceInfo?.platform,
      operatingSystem: deviceInfo?.operatingSystem,
      osVersion: deviceInfo?.osVersion,
      connected: true,
      criado_em: fb.firebase.firestore.FieldValue.serverTimestamp(),
    }
    // sem await: offline a promise de escrita só resolve quando o servidor confirmar
    deviceRef.set(data).catch((err) => console.warn('updateDeviceToken', err));
    // console.log(`DEBUG updateDeviceToken saved: ${JSON.stringify(data)}`);
  }
  // else {
  //   console.log(`DEBUG updateDeviceToken not saved: ${fcmToken} - ${app.loggedIn}`);
  // }
}

export const disableDeviceToken = async () => {
  if (!isSupported())
    return;

  const fcmToken = await localForage.getItem<string>('fcmToken');
  if (!fcmToken)
    return;

  // update User fcmToken
  const device = await fb.db.collection('devices').doc(fcmToken).get();
  if (!device.exists)
    return;

  await device.ref.update({connected: false});
  // console.log(`DEBUG disableDeviceToken saved: ${fcmToken}`);
}
